// extracted by mini-css-extract-plugin
module.exports = {"menu":"TurkeyBurgerMenu-styles-module--menu--2y7Rs","bar":"TurkeyBurgerMenu-styles-module--bar--28Hv-"};